// DatePicker semplice con input nativo — accessibile
import { forwardRef } from 'react'
import { cn } from '../../lib/utils'

interface DatePickerProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
  hint?: string
  wrapperClassName?: string
}

export const DatePicker = forwardRef<HTMLInputElement, DatePickerProps>(
  ({ className, label, error, hint, wrapperClassName, id, ...props }, ref) => {
    const inputId = id ?? label?.toLowerCase().replace(/\s+/g, '-') ?? 'date-picker'

    return (
      <div className={cn('flex flex-col gap-1', wrapperClassName)}>
        {label && (
          <label htmlFor={inputId} className="text-sm font-medium text-[var(--fc-foreground)]">
            {label}
            {props.required && <span className="ml-1 text-[var(--fc-danger)]" aria-hidden="true">*</span>}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          type="date"
          className={cn(
            'h-10 w-full rounded border border-[var(--fc-border)] bg-[var(--fc-surface)] px-3 py-2 text-sm text-[var(--fc-foreground)]',
            'focus:border-[var(--fc-primary)] focus:outline-none focus:ring-1 focus:ring-[var(--fc-primary)]',
            'disabled:cursor-not-allowed disabled:opacity-50',
            error && 'border-[var(--fc-danger)]',
            className
          )}
          aria-invalid={Boolean(error)}
          {...props}
        />
        {error && <p className="text-xs text-[var(--fc-danger)]" role="alert">{error}</p>}
        {hint && !error && <p className="text-xs text-[var(--fc-foreground-muted)]">{hint}</p>}
      </div>
    )
  }
)

DatePicker.displayName = 'DatePicker'
